export default {
    handleErrosDepartamento(errorData, errorForm) {
        let error = errorData.errors;

        errorForm.errorName = error.descricao ? error.descricao[0] :  null;
        errorForm.errorUf = error.uf ? error.uf[0] : null;
        errorForm.acronym = error.sigla ? error.sigla[0] : null;
        errorForm.erroResponsible = error.id_usuario_responsavel ? error.id_usuario_responsavel[0] : null;
    }
}